var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { getMunicipiosBR } from "../../apis/municipiosApi";
import { UfEnumOptions } from "../../model/enums/UfEnum";
import { isCepValid } from "./ValidationUtils";
export var handleBlurCep = function (_a) {
    var cep = _a.cep, setLoadingBuscaCep = _a.setLoadingBuscaCep, data = _a.data, setData = _a.setData;
    return __awaiter(void 0, void 0, Promise, function () {
        var urlViaCep, response_1, municipios, municipioEncontrado, e_1;
        var _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    urlViaCep = "https://viacep.com.br/ws/".concat(cep, "/json/");
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 4, 5, 6]);
                    if (!cep || !isCepValid(cep))
                        return [2 /*return*/];
                    setLoadingBuscaCep(true);
                    return [4 /*yield*/, axios.get(urlViaCep)];
                case 2:
                    response_1 = _g.sent();
                    if ((_b = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _b === void 0 ? void 0 : _b.erro) {
                        setLoadingBuscaCep(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getMunicipiosBR()];
                case 3:
                    municipios = _g.sent();
                    municipioEncontrado = municipios.find(function (item) { var _a, _b; return (item === null || item === void 0 ? void 0 : item.nome) === ((_a = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _a === void 0 ? void 0 : _a.localidade) && (item === null || item === void 0 ? void 0 : item.uf) === ((_b = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _b === void 0 ? void 0 : _b.uf); });
                    setData(__assign(__assign(__assign({}, data), data.pessoaFisica), { bairro: (_c = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _c === void 0 ? void 0 : _c.bairro, endereco: (_d = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _d === void 0 ? void 0 : _d.logradouro, estado: (_f = (_e = UfEnumOptions.getOptions().find(function (it) { var _a; return it.value === ((_a = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _a === void 0 ? void 0 : _a.uf); })) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : null, municipio: municipioEncontrado !== null && municipioEncontrado !== void 0 ? municipioEncontrado : undefined }));
                    return [3 /*break*/, 6];
                case 4:
                    e_1 = _g.sent();
                    console.error(e_1);
                    return [3 /*break*/, 6];
                case 5:
                    setLoadingBuscaCep(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    });
};
export var handleBlurCepRespTec = function (_a) {
    var cep = _a.cep, setLoadingBuscaCep = _a.setLoadingBuscaCep, data = _a.data, setData = _a.setData;
    return __awaiter(void 0, void 0, Promise, function () {
        var urlViaCep, response_2, municipios, e_2;
        var _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    urlViaCep = "https://viacep.com.br/ws/".concat(cep, "/json/");
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 4, 5, 6]);
                    if (!cep || !isCepValid(cep))
                        return [2 /*return*/];
                    setLoadingBuscaCep(true);
                    return [4 /*yield*/, axios.get(urlViaCep)];
                case 2:
                    response_2 = _g.sent();
                    if ((_b = response_2 === null || response_2 === void 0 ? void 0 : response_2.data) === null || _b === void 0 ? void 0 : _b.erro) {
                        setLoadingBuscaCep(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getMunicipiosBR()];
                case 3:
                    municipios = _g.sent();
                    setData(__assign(__assign({}, data), { bairro: (_c = response_2 === null || response_2 === void 0 ? void 0 : response_2.data) === null || _c === void 0 ? void 0 : _c.bairro, endereco: (_d = response_2 === null || response_2 === void 0 ? void 0 : response_2.data) === null || _d === void 0 ? void 0 : _d.logradouro, estado: (_f = (_e = UfEnumOptions.getOptions().find(function (it) { var _a; return it.value === ((_a = response_2 === null || response_2 === void 0 ? void 0 : response_2.data) === null || _a === void 0 ? void 0 : _a.uf); })) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : null, municipio: municipios.filter(function (item) { var _a; return (item === null || item === void 0 ? void 0 : item.nome) === ((_a = response_2 === null || response_2 === void 0 ? void 0 : response_2.data) === null || _a === void 0 ? void 0 : _a.localidade); })[0] }));
                    return [3 /*break*/, 6];
                case 4:
                    e_2 = _g.sent();
                    console.error(e_2);
                    return [3 /*break*/, 6];
                case 5:
                    setLoadingBuscaCep(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    });
};
